import { Text } from '@/components';
import { getProjectDetailPageUrl } from '@/features/project/_utils/project';
import { isPS } from '@/utils';

export const LedgerTitle = ({
  projectId,
  projectName,
}: { projectId: string | undefined; projectName: string | undefined }) => {
  const Title = <Text text={projectName} variant="h4" />;

  if (!projectId) {
    return Title;
  }

  return (
    <div>
      <a
        href={getProjectDetailPageUrl({ isPS: isPS(), projectId })}
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        {Title}
      </a>
    </div>
  );
};
